
import request from '@/utils/request'

// 获取账户列表
export function getAccountList(params) {
  return request({
    url: `/ocean/advertiser/ocean_accounts`,
    method: 'get',
    params
  })
}

// 授权
export function toGrantAuthorization(params) {
  return request({
    url: `/ocean/auth_url`,
    method: 'get',
    params
  })
}

// 广告计划列表
export function getAdvertiserList(params = {}) {
  return request({
    url: `/ocean/advertisement/ocean_ads`,
    method: 'get',
    params
  })
}

// 获取广告组列表
export function getAdvertisingGroupList(params = {}) {
  return request({
    url: `/ocean/advertisement/ocean_campaigns`,
    method: 'get',
    params
  })
}

// 获取广告主数据
export function getAdvertiserData(data = {}) {
  return request({
    url: `/ocean/advertising/advertisergod`,
    method: 'post',
    data
  })
}

// 获取广告组数据
export function getAdGroupData(data = {}) {
  return request({
    url: `/ocean/advertising/advertisergroup`,
    method: 'post',
    data
  })
}

// 获取广告计划数据
export function getAdvertisingPlanData(data = {}) {
  return request({
    url: `/ocean/advertising/advertiserplan`,
    method: 'post',
    data
  })
}

// 获取广告创意数据
export function getAdvertisingCreativeData(data = {}) {
  return request({
    url: `/ocean/advertising/advertiseridea`,
    method: 'post',
    data
  })
}

// 获取人群包列表
export function getCrowdPackageList(params = {}) {
  return request({
    url: `/ocean/dmp/crowbag`,
    method: 'get',
    params
  })
}

// 获取人群包详细信息
export function getCrowdPackDetails(params = {}) {
  return request({
    url: `/ocean/dmp/crowbagdetail`,
    method: 'get',
    params
  })
}

// 发布人群包
export function releaseCrowdPackage(params = {}) {
  return request({
    url: `/ocean/dmp/shootcrowbag`,
    method: 'get',
    params
  })
}

// 删除人群包
export function deleteCrowdPackage(params = {}) {
  return request({
    url: `/ocean/dmp/delcrowbag`,
    method: 'get',
    params
  })
}

// 推送人群包
export function pushCrowdPack(params = {}) {
  return request({
    url: `/ocean/dmp/pushcrowbag`,
    method: 'get',
    params
  })
}
// 小程序链接列表
export function copyv2urllist(params = {}) {
  return request({
    url: `/ocean/copy_v2/url_list`,
    method: 'get',
    params
  })
}
// 新增小程序链接
export function oceancopyv2urlcreate(data = {}) {
  return request({
    url: `/ocean/copy_v2/url_create`,
    method: 'post',
    data
  })
}
// 删除小程序链接
export function oceancopyv2urldelete(data = {}) {
  return request({
    url: `/ocean/copy_v2/url_delete`,
    method: 'post',
    data
  })
}
// 爱奇艺账户列表
export function iqiyiadvertiserlist(params = {}) {
  return request({
    url: `/iqiyi/advertiser/list`,
    method: 'get',
    params
  })
}
// 爱奇艺授权账户
export function iqiyiadvertiserauthurl(params = {}) {
  return request({
    url: `/iqiyi/advertiser/auth_url`,
    method: 'get',
    params
  })
}
// 巨量账户列表导出
export function advertiserExport(params = {}) {
  return request({
    url: `/ocean/advertiser/export`,
    method: 'get',
    params
  })
}
